import { css } from 'styled-components'

const itemHighlight = css`
  transition: background-color 0.3s ease-in-out 0s;
  &.item-highlight {
    background: ${props => props.theme.notificationHighlight};
  }
`

export default itemHighlight
